<template>
  <div class="ab_a-action">
    <slot name="before"></slot>
    <slot>
      <div class="ab_a-action_action-wrapper">
        <div
          class="ab_a-action_action"
          v-html="
            `
            ${getBetHtml({
              showBetsIn,
              a: action,
              name: true,
            })}${
              action.type === 'RAISE' &&
              action.real_raise_amount &&
              action.real_raise_amount !== action.raise_amount
                ? `<span class='bet-as-pot'>(${getBetHtml({
                    showBetsIn:
                      showBetsIn === 'bb_and_pot'
                        ? 'bb'
                        : showBetsIn === 'pot_and_bb'
                          ? 'bb'
                          : showBetsIn,
                    a: {
                      raise_amount: action.real_raise_amount,
                      amount_by_pot: action.real_amount_by_pot,
                    },
                    name: false,
                  })})</span>`
                : ''
            }`
          "
        />
      </div>
    </slot>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'

export default {
  name: 'HaAction',
  mixins: [format_mix],
  props: {
    action: { default: () => ({}) },
    // spot: Object,
    showBetsIn: String,
    // hasBBPot: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_a-action {
    padding-left: 2px;
    color: var(--ha-aa-color);
    min-width: var(--ha-aa-width);
    min-height: var(--ha-aa-height);
    display: var(--ha-aa-cell-display);
    font-size: var(--ha-aa-size);
    font-weight: var(--ha-aa-weight);

    flex-wrap: wrap;
    white-space: nowrap;
    position: relative;
    z-index: 3;

    &:hover {
      z-index: 3;
      .ab_a-action_action-wrapper {
        background: var(--btn-back-clr-back);
        z-index: 3;
        max-width: var(--ha-aa-hovered-max-width);
        transition: 0.22s;
        padding-right: 0.25rem;
      }
    }
    &_action {
      &-wrapper {
        max-width: var(--ha-aa-max-width);
        position: absolute;
        display: var(--ha-aa-cell-display);
      }
      background: var(--ha-aa-selected-background);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  &_real-bet {
    color: var(--ha-aa-rlb-color);
    font-size: var(--ha-aa-rml-bet-font-size);
    font-weight: var(--ha-aa-rml-bet-font-weight);
    line-height: var(--ha-aa-rml-bet-line-height);
    padding-left: 2px;
    position: relative;
    z-index: 2;
  }
}
</style>
